import { createRoute, dynamicWrapper } from '@/utils/core';

const routesConfig = (app) => ({
    path: '/SecurityLedger/index',
    title: '安全台账',
    component: dynamicWrapper(app, [], () => import('./components'))
});

export default (app) => createRoute(app, routesConfig);
